import { styled } from 'styled-components'

import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import {
  inventoryGroupsQuery,
  type OrchestratedListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'

const Container = styled.div`
  max-width: 100%;
  width: 100%;
`

import { Shipment } from './Shipment'

export const ShipmentInformation = ({
  listing,
  hazmatOnly = false,
}: {
  listing: OrchestratedListingDetails
  hazmatOnly?: boolean
}) => {
  const inventoryGroupsQueryResult = inventoryGroupsQuery.useQuery(
    listing.lot._id
  )

  {
    return (
      <Container>
        <QueryLoadingManager {...inventoryGroupsQueryResult}>
          {({ data }) =>
            data?.groups ? (
              <Shipment
                groups={data.groups}
                details={listing}
                hazmatOnly={hazmatOnly}
              />
            ) : null
          }
        </QueryLoadingManager>
      </Container>
    )
  }
}
